export default "__VITE_ASSET__BtkypsWc__"